import { createStore, applyMiddleware } from "redux";
import loansysApp from "../reducer";
import thunk from "redux-thunk";
import api from "admin/middlewares/api";
import { browserHistory } from "react-router";
import { routerMiddleware } from "react-router-redux";

const reduxRouterMiddleware = routerMiddleware(browserHistory);

export default function configureStore(initialState) {
  return createStore(
    loansysApp,
    initialState,
    applyMiddleware(thunk, reduxRouterMiddleware, api),
  );
}
